<div class="flex justify-center items-center">
  <div class="ai-icon-container">
    <svg class="star-1">
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
    <svg class="star-2">
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
    <svg class="star-3">
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
  </div>
</div>
